'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'

export default function EquipmentPage() {
  const { theme } = useTheme()
  const equipmentGuides = [
    { title: '마스크 선택법', href: '/equipment/mask', desc: '나에게 맞는 마스크 고르기' },
    { title: '핀 종류와 선택', href: '/equipment/fins', desc: '롱핀, 숏핀 비교' },
    { title: '슈트 가이드', href: '/equipment/wetsuit', desc: '웻슈트 선택 가이드' },
    { title: '웨이트벨트 사용법', href: '/equipment/weight-belt', desc: '적정 웨이트 계산' },
    { title: '스노클 선택 가이드', href: '/equipment/snorkel', desc: '스노클 종류와 사용법' },
  ]

  return (
    <div className={`min-h-screen py-2 xxs:py-1.5 px-3 xxs:px-2 ${
      theme === 'light' ? 'bg-white' : 'bg-gray-900'
    }`}>
      <div className="max-w-6xl mx-auto">
        <h1 className={`text-base xxs:text-sm font-bold mb-1.5 xxs:mb-1 ${
          theme === 'light' ? 'text-gray-900' : 'text-white'
        }`}>장비 가이드</h1>
        <p className={`text-xs xxs:text-[10px] mb-3 xxs:mb-2 ${
          theme === 'light' ? 'text-gray-600' : 'text-gray-400'
        }`}>
          프리다이빙 장비 선택과 사용법을 알아보세요.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 xxs:gap-1.5">
          {equipmentGuides.map((guide) => (
            <Link
              key={guide.href}
              href={guide.href}
              className={`p-3 xxs:p-2 rounded-lg shadow-md hover:shadow-xl transition-all ${
                theme === 'light'
                  ? 'bg-white border border-gray-200'
                  : 'bg-gray-800 border border-gray-700'
              }`}
            >
              <h3 className={`text-sm xxs:text-xs font-bold mb-1 xxs:mb-0.5 ${
                theme === 'light' ? 'text-gray-900' : 'text-white'
              }`}>{guide.title}</h3>
              <p className={`text-xs xxs:text-[10px] ${
                theme === 'light' ? 'text-gray-600' : 'text-gray-400'
              }`}>{guide.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
